import React, { useState, useEffect } from 'react';

import { uuid } from 'uuidv4';
import { FiUsers, FiUserPlus, FiCreditCard, FiUserCheck } from 'react-icons/fi';
import { FaCreditCard } from 'react-icons/fa';

import { apiUrl } from '../../config';
import {
  SearchComponent,
  ISearchComponent,
} from '../../components/SearchComponent';

import CounterCard from '../../components/CounterCard';
import CounterCardRepeat from '../../components/CounterCardRepeat';
import api from '../../services/api';
import {
  Container,
  Header,
  Body,
  Tabs,
  CardContainer,
  SideTab,RoomReport,RoomReportDiv
} from './styles';

import { useAuth } from '../../hooks/Auth';
import Lessons from '../Lesson';
import Sale from '../Sale';
import Expositor from '../ExpositorAdmin';
import Speaker from '../SpeakerAdmin';
import Students from '../Student';
import Program from '../ProgramAdmin';
import Courses from '../Course';
import ExpositorVote from '../ExpositorVote';
import Certificados from '../CertificadosAdmin';
import { clearInterval } from 'timers';
import { AiOutlineLike } from 'react-icons/ai';

interface IReport {
  id : number,
  client_id : number,
  room_id : number,
  name : string,
}

interface IOnline {
  title : string;
  room_id : number;
  count : number;
}

const Dashboard: React.FC = () => {
  const endpoint = '/students';

  const { token, user } = useAuth();

  const [online, setOnline] = useState(0);
  const [loading, setLoading] = useState(false);
  const [showOnlineUsers, setShowOnlineUsers] = useState(false);
  const [report, setReport] = useState<Array<IReport>>([]);
  const [search, setSearch] = useState('student');
  const [rooms, setRooms] = useState<Array<IOnline>>([]);

  const validSearch: Record<string, any> = {
    student: () => <Students />,
    sale: () => <Sale />,
    speaker : () => <Speaker />,
    expositor: () => <Expositor />,
    course: () => <Courses />,
    lesson: () => <Lessons />,
    vote: () => <ExpositorVote />,
    program : () => <Program/>,
    certificate : () => <Certificados/>
  };


  useEffect(() => {

    const load = async () => {

      const response = await api.get('/report/onlinePlayersRooms');

      if(response && response.data && response.data.counter){
        setRooms(response.data.counter);
      }




    }
    load();

  }, []);


  if (loading) {
    return <Container>Você foi removido</Container>;
  }

  return (
    <Container>
      <CardContainer>
        {user.profile === 1 && <>


        <CounterCard
          endpoint="/report/active_users"
          title="Usuários ativos"
          Icon={FiUserCheck}
        /> </>}
        <CounterCardRepeat
          endpoint="/report/onlinePlayers"
          title="Usuários Online"
          Icon={FiUserPlus}
        />
        <CounterCard
          endpoint="/report/users"
          title="Usuários Cadastrados"
          Icon={FiUsers}
        />
         {user.profile === 1 && <>
        <CounterCard
          endpoint="/report/sales_paid"
          title="Vendas Finalizadas"
          Icon={FiCreditCard}
        />
        <CounterCard
          endpoint="/report/sales_waiting"
          title="Vendas Aguardando"
          Icon={FaCreditCard}
        /> </>}



      </CardContainer>

<RoomReportDiv>
      {rooms && rooms.map(r => <RoomReport key={`room${r.room_id}`}><p className="p1">{r.title || 'Fora da Sala'} </p><p>{r.count || 0} usuários </p></RoomReport>)}
      </RoomReportDiv>
      <Tabs>
      <button type="button" onClick={() => setSearch('student')}>
          Participantes
        </button>
        {user.profile === 1 && <>
        <button type="button" onClick={() => setSearch('expositor')}>
          Expositores
        </button>
        <button type="button" onClick={() => setSearch('speaker')}>
          Palestrantes
        </button>
        <button type="button" onClick={() => setSearch('certificate')}>
          Certificados
        </button>
        <button type="button" onClick={() => setSearch('program')}>
          Programação
        </button>
   
      
        <button type="button" onClick={() => setSearch('sale')}>
          Vendas
        </button>
        <button type="button" onClick={() => setSearch('lesson')}>
          Lives
        </button>
        <button type="button" onClick={() => setSearch('course')}>
          Categorias
        </button> </>
      }
      </Tabs>

      {validSearch[search] ? validSearch[search]() : <></>}

{showOnlineUsers &&
<SideTab>
<ul>
        {report.map(item => (
          <li key={item.id}>
            <div className="image"></div>
            <div className="text">
              <h3>{item.name}</h3>
              <p>{item.room_id ?  `Sala ${item.room_id}`: ''}</p>
              </div>
          </li>
        ))}
      </ul>
</SideTab>
}
    </Container>
  );
};

export default Dashboard;
